module.exports = __webpack_public_path__ + "static/media/home_icon.bddece40.svg";